import audit from './zh-CN/audit';
import auditOverview from './zh-CN/audit-overview';
import bankConfig from './zh-CN/bank-config';
import budgetRequest from './zh-CN/budget-request';
import building from './zh-CN/building';
import component from './zh-CN/component';
import dailyReport from './zh-CN/daily-report';
import decoration from './zh-CN/decoration';
import electricFee from './zh-CN/electric-fee';
import entryRegistration from './zh-CN/entry-registration';
import error from './zh-CN/error';
import finance from './zh-CN/finance';
import financeReconciliation from './zh-CN/finance-reconciliation';
import globalHeader from './zh-CN/globalHeader';
import guest from './zh-CN/guest';
import handleHall from './zh-CN/hall-rental';
import house from './zh-CN/house';
import housekeeper from './zh-CN/housekeeper';
import houseUser from './zh-CN/houseUser';
import importNotice from './zh-CN/import-notice';
import menu from './zh-CN/menu';
import moveOut from './zh-CN/moveout';
import netFee from './zh-CN/net-fee';
import serviceOpenService from './zh-CN/open-service';
import orderNo from './zh-CN/order-no';
import otherFee from './zh-CN/other-fee';
import pages from './zh-CN/pages';
import parking from './zh-CN/parking';
import parkingFee from './zh-CN/parking-fee';
import pay from './zh-CN/pay';
import propertyAgent from './zh-CN/property-agent';
import propertyFee from './zh-CN/property-fee';
import propertyOverview from './zh-CN/property-overview';
import pwa from './zh-CN/pwa';
import rental from './zh-CN/rental';
import repair from './zh-CN/repair';
import salesAgent from './zh-CN/sales-agent';
import salesOverview from './zh-CN/sales-overview';
import serviceConfig from './zh-CN/service-config';
import settingDrawer from './zh-CN/settingDrawer';
import settings from './zh-CN/settings';
import sys from './zh-CN/sys';
import waterFee from './zh-CN/water-fee';

export default {
  'navBar.lang': '语言',
  'layout.user.link.help': '帮助',
  'layout.user.link.privacy': '隐私',
  'layout.user.link.terms': '条款',
  'app.preview.down.block': '下载此页面到本地项目',
  'app.welcome.link.fetch-blocks': '获取全部区块',
  'app.welcome.link.block-list': '基于 block 开发，快速构建标准页面',
  ...pages,
  ...globalHeader,
  ...menu,
  ...settingDrawer,
  ...settings,
  ...pwa,
  ...component,
  ...audit,
  ...auditOverview,
  ...pay,
  ...finance,
  ...budgetRequest,
  ...serviceConfig,
  ...serviceOpenService,
  ...handleHall,
  ...parkingFee,
  ...propertyFee,
  ...waterFee,
  ...electricFee,
  ...netFee,
  ...otherFee,
  ...parking,
  ...house,
  ...building,
  ...houseUser,
  ...housekeeper,
  ...guest,
  ...decoration,
  ...moveOut,
  ...entryRegistration,
  ...error,
  ...salesOverview,
  ...propertyAgent,
  ...salesAgent,
  ...financeReconciliation,
  ...sys,
  ...repair,
  ...dailyReport,
  ...importNotice,
  ...orderNo,
  ...bankConfig,
  ...propertyOverview,
  ...rental,
};
